import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";

const ACK_KEY = "sp_cookie_notice_ack";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(ACK_KEY)) setVisible(true);
    } catch (_) { /* storage blocked - stay hidden */ }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(ACK_KEY, new Date().toISOString()); } catch (_) { /* noop */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[250]" data-testid="cookie-banner">
      <div className="rounded-2xl border border-border bg-[hsl(var(--card)/0.85)] backdrop-blur-xl shadow-[0_18px_50px_-20px_rgba(0,0,0,0.35)] p-4">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded-lg bg-secondary flex items-center justify-center shrink-0"><Cookie className="w-4 h-4 text-primary" /></div>
          <div className="flex-1 min-w-0">
            <p className="text-sm leading-relaxed">
              We only use <strong>essential storage</strong> to keep you signed in — no ad trackers, ever.{" "}
              <Link to="/legal/cookies" className="text-primary hover:underline" data-testid="cookie-banner-notice-link">Read our Cookie Notice</Link>.
            </p>
            <div className="mt-3">
              <Button size="sm" className="rounded-lg h-8" onClick={dismiss} data-testid="cookie-banner-accept-button">Got it</Button>
            </div>
          </div>
          <button onClick={dismiss} aria-label="Dismiss cookie notice" className="text-muted-foreground hover:text-foreground transition-colors shrink-0" data-testid="cookie-banner-dismiss-button">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
